import Image_Default from "../../images/man.png";
import { useNavigate } from "react-router-dom";
import {connect} from "react-redux";
import React from "react";
import Button_Logout from "./Button_Logout";

const Nav_UserInfo = (props) => {
    const navigate = useNavigate();
    const {firstName,userName} = props.user;

    const toProfile = () => {
        try {
            navigate("/profile");
        } catch (error) {
            console.log(error);
        }
    }
    return(
        <footer className={`nav_footer background_change_hover background_change_hover_${props.color_background}`}>
            <div className="nav_userinfo" onClick={toProfile}>
                <img className="user_image" src={Image_Default} alt="User" />
                <div className="nav_username_div">
                    <span className="name">{firstName}</span>
                    <span className="username">@{userName}</span>
                </div>
            </div>
            <Button_Logout />
        </footer>
    )
}

const mapStateToProps = (state) => {
    return {
        color_background: state.getColorBackground.color_background,
        user: state.getUser.user
    }
}
export default connect(mapStateToProps)(Nav_UserInfo);